import React, { Component } from 'react';

class Promo extends Component {
  render() {
    return (
      <section className={"hero is-bold is-small " + this.props.class}>
        <div className="hero-body">
          <div className="container">
            <h1 className="title">
              <i className={"fa " + this.props.icon}></i> 
              {this.props.body}
            </h1>
            <h2 className="subtitle">
              {this.props.subtitle}
            </h2>
          </div>
        </div>
      </section>
    );
  }
}

export default Promo;



// WEBPACK FOOTER //
// ./src/components/articles/Promo.jsx